const safeFilename = (value) => {
  const filename = String(value || "").trim();
  return filename || "Document";
};

const extensionOf = (filename) => {
  const match = safeFilename(filename).toLowerCase().match(/\.([a-z0-9]+)$/);
  return match ? match[1] : "";
};

export const normalizeClientDocumentRow = (row) => {
  if (!row || typeof row !== "object") return row;

  const document = safeFilename(row.document ?? row.original_filename);
  return {
    ...row,
    document,
    document_url: row.document_url ?? row.download_url ?? "",
    extension: extensionOf(document),
    original_filename: row.original_filename ?? document,
    updated_at: row.updated_at ?? row.created_at ?? "",
  };
};

export const normalizeClientDocumentResponse = (response) => {
  if (Array.isArray(response)) return response.map(normalizeClientDocumentRow);
  if (!response || typeof response !== "object") return response;
  if (!Array.isArray(response.data)) return normalizeClientDocumentRow(response);
  return {
    ...response,
    data: response.data.map(normalizeClientDocumentRow),
  };
};
